import { useContext } from 'preact/hooks';
import { SelectionContext, UpdateSelectionContext } from './SelectionsContext';

export const UsePreferenceSelections = () => {
  const { preferenceSelections } = useContext(SelectionContext);
  const { setPreferenceSelections} = useContext(UpdateSelectionContext);

  return { preferenceSelections, setPreferenceSelections};
};
